export const paginationTemplate4 = [
  '1-4',
  '5-8',
  '9-12',
  '13-16',
  '17-20',
  '21-24',
  '25-28',
  '29-32',
  '33-36',
  '37-40',
  '41-44',
  '45-48',
  '49-52',
  '53-56',
  '57-60',
  '61-64'
];

export const paginationTemplate6 = [
  '1-6',
  '7-12',
  '13-18',
  '19-24',
  '25-30',
  '31-36',
  '37-42',
  '43-48',
  '49-54',
  '55-60',
  '61-64'
];

export const paginationTemplate9 = [
  '1-9',
  '10-18',
  '19-27',
  '28-36',
  '37-45',
  '46-54',
  '55-63',
  '64'
];

export const paginationTemplate12 = [
  '1-12',
  '13-24',
  '25-36',
  '37-48',
  '49-60',
  '61-64'
];

export const paginationTemplate16 = [
  '1-16',
  '17-32',
  '33-48',
  '28-36',
  '37-45',
  '46-54',
  '55-63',
  '64'
];

export const eightHrTimeFrame1 = [
  {label: '12am', t: '00000000000000'},
  {label: '1am', t: '00000000013000'},
  {label: '2am', t: '00000000030000'},
  {label: '3am', t: '00000000043000'},
  {label: '4am', t: '00000000060000'},
  {label: '5am', t: '00000000073000'},
  {label: '6am', t: '00000000090000'},
  {label: '7am', t: '00000000103000'},
  {label: '8am', t: '00000000120000'}
];

export const eightHrTimeFrame2 = [
  {label: '8am', t: '00000000000000'},
  {label: '9am', t: '00000000013000'},
  {label: '10am', t: '00000000030000'},
  {label: '11am', t: '00000000043000'},
  {label: '12pm', t: '00000000060000'},
  {label: '1pm', t: '00000000073000'},
  {label: '2pm', t: '00000000090000'},
  {label: '3pm', t: '00000000103000'},
  {label: '4pm', t: '00000000120000'}
];

export const eightHrTimeFrame3 = [
  {label: '4pm', t: '00000000000000'},
  {label: '5pm', t: '00000000013000'},
  {label: '6pm', t: '00000000030000'},
  {label: '7pm', t: '00000000043000'},
  {label: '8pm', t: '00000000060000'},
  {label: '9pm', t: '00000000073000'},
  {label: '10pm', t: '00000000090000'},
  {label: '11pm', t: '00000000103000'},
  {label: '12am', t: '00000000120000'}
];

export const fourHrTimeFrame1 = [
  {label: '12am', t: '00000000000000'},
  {label: '1am', t: '00000000030000'},
  {label: '2am', t: '00000000060000'},
  {label: '3am', t: '00000000090000'},
  {label: '4am', t: '00000000120000'}
];

export const fourHrTimeFrame2 = [
  {label: '4am', t: '00000000000000'},
  {label: '5am', t: '00000000030000'},
  {label: '6am', t: '00000000060000'},
  {label: '7am', t: '00000000090000'},
  {label: '8am', t: '00000000120000'}
];

export const fourHrTimeFrame3 = [
  {label: '8am', t: '00000000000000'},
  {label: '9am', t: '00000000030000'},
  {label: '10am', t: '00000000060000'},
  {label: '11am', t: '00000000090000'},
  {label: '12pm', t: '00000000120000'}
];

export const fourHrTimeFrame4 = [
  {label: '12pm', t: '00000000000000'},
  {label: '1pm', t: '00000000030000'},
  {label: '2pm', t: '00000000060000'},
  {label: '3pm', t: '00000000090000'},
  {label: '4pm', t: '00000000120000'}
];

export const fourHrTimeFrame5 = [
  {label: '4pm', t: '00000000000000'},
  {label: '5pm', t: '00000000030000'},
  {label: '6pm', t: '00000000060000'},
  {label: '7pm', t: '00000000090000'},
  {label: '8pm', t: '00000000120000'}
];

export const fourHrTimeFrame6 = [
  {label: '8pm', t: '00000000000000'},
  {label: '9pm', t: '00000000030000'},
  {label: '10pm', t: '00000000060000'},
  {label: '11pm', t: '00000000090000'},
  {label: '12am', t: '00000000120000'}
];

export const fourHrIndecies = ['12am - 4am', '4am - 8am', '8am - noon', 'noon - 4pm', '4pm - 8pm', '8pm - 12am'];
export const eightHrIndecies = ['12am - 8am', '8am - 4pm', '4pm - 12am'];
export const twelveHrIndecies = ['12am - noon', 'noon - 12am'];